import React from "react"

const SectionHowItWorks = () => (
  <section className="how-sec alt">
    <div className="wrap">
      <h2>How CJR-X works</h2>
      <ol className="flow">
        <li>
          <span className="fn">1</span>
          <b>Care is billed as usual</b>
          <span>Providers bill Medicare through the 90-day episode.</span>
        </li>
        <li>
          <span className="fn">2</span>
          <b>CMS sets a regional target</b>
          <span>Census division spending, risk adjusted, less 2%.</span>
        </li>
        <li>
          <span className="fn">3</span>
          <b>CMS reconciles yearly</b>
          <span>Spending is compared to target from year one.</span>
        </li>
        <li>
          <span className="fn">4</span>
          <b>Quality comes first</b>
          <span>Meet the minimum quality score to earn a payment.</span>
        </li>
      </ol>
      <h3 className="sub-h">Risk limits</h3>
      <p className="sub-p">
        Gains and losses are capped as a share of target spending. Two-sided
        risk applies from the first year.
      </p>
      <div className="tiers t2">
        <div className="tier r3">
          <div className="tier-h">
            <span className="tier-n">Most hospitals</span>
            <span className="tier-tag">Standard</span>
          </div>
          <div className="tier-body">
            <div className="tier-stat g">
              <b>20%</b>
              <span>maximum gain</span>
            </div>
            <div className="tier-stat l">
              <b>20%</b>
              <span>maximum loss</span>
            </div>
          </div>
          <div className="tier-who">
            <span>Who</span>Acute care hospitals paid under both the IPPS and
            OPPS
          </div>
        </div>
        <div className="tier r2">
          <div className="tier-h">
            <span className="tier-n">Protected hospitals</span>
            <span className="tier-tag">Lower loss limit</span>
          </div>
          <div className="tier-body">
            <div className="tier-stat g">
              <b>20%</b>
              <span>maximum gain</span>
            </div>
            <div className="tier-stat l">
              <b>5%</b>
              <span>maximum loss</span>
            </div>
          </div>
          <div className="tier-who">
            <span>Who</span>Safety net, rural, Medicare-dependent, and sole
            community hospitals
          </div>
        </div>
      </div>
      <div className="qwide">
        <div className="qw-txt">
          <h3>Quality comes first</h3>
          <p>
            A hospital must reach a minimum composite quality score to earn any
            payment. Stronger quality lowers the discount CMS applies.
          </p>
        </div>
        <div className="qw-viz">
          <div
            className="qw-bar"
            role="img"
            aria-label="Complications 50 percent, patient experience 40 percent, patient-reported outcomes 10 percent"
          >
            <div className="q1" style={{ flex: "50" }}>
              <b>50%</b>
            </div>
            <div className="q2" style={{ flex: "40" }}>
              <b>40%</b>
            </div>
            <div className="q3" style={{ flex: "10" }}>
              <b>10%</b>
            </div>
          </div>
          <div className="qw-leg">
            <span>
              <i className="q1" />
              Complications
            </span>
            <span>
              <i className="q2" />
              Patient experience
            </span>
            <span>
              <i className="q3" />
              Patient-reported outcomes
            </span>
          </div>
        </div>
      </div>
      <h3 className="tl-h">What’s ahead</h3>
      <ol className="htl" style={{ gridTemplateColumns: "repeat(4,1fr)" }}>
        <li className="next">
          <span className="hd">End 2026</span>
          <span className="ht">Participant list expected</span>
        </li>
        <li>
          <span className="hd">Jul 2027</span>
          <span className="ht">Risk lookback begins</span>
        </li>
        <li>
          <span className="hd">Jan 2028</span>
          <span className="ht">Year 1, two-sided risk</span>
        </li>
        <li>
          <span className="hd">2029</span>
          <span className="ht">First reconciliation</span>
        </li>
      </ol>
    </div>
  </section>
)

export default SectionHowItWorks
